<template>
	<div class="field">
		<label for="cartype">Fahrzeugklasse:</label>
		<select @change="selectCartype" :value="selectedCartypeId" id="cartype" name="cartype">
			<option v-for="cartype in cartypes" :key="cartype.id" :value="cartype.id">{{ cartype.name }}</option>
		</select>
	</div>
</template>

<script>
export default {
	computed: {
		cartypes() {
			return this.$store.getters.getCartypes
		},
		selectedCartypeId() {
			return this.$store.getters.getSelectedCartypeId
		}
	},
	methods: {
		selectCartype(event) {
			this.$store.commit({
				type:'setCartype',
				id: event.target.value
			});
			this.$store.dispatch('updatePrices');
		}
	}
}
</script>
